import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { EmployeeVM } from '@app/cem/project/models/employee-vm';
import { Employee } from '@app/shared/models';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-employee-filter',
  templateUrl: './employee-filter.component.html',
  styleUrls: ['./employee-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ComboBoxComponent,
  ],
})
export class EmployeeFilterComponent extends BaseFilterCellComponent implements OnInit {
  readonly inFilter = input<CompositeFilterDescriptor>(undefined);
  readonly data = input<Employee[]>(undefined);
  readonly valueField = input<string>(undefined);
  readonly filterField = input<string>(undefined);
  public textField: string = "FullName";
  public selectedItem: EmployeeVM;

  public filteredData: EmployeeVM[] = [];

  public get defaultItem(): any {
    return {
      [this.textField]: "Select item...",
      [this.valueField()]: null
    };
  }

  constructor() {
    const filterService = inject(FilterService);
    super(filterService);
  }

  public ngOnInit(): void {
    this.filter = this.inFilter();
  }

  public onChange(value: any): void {
    let compositeFilter: CompositeFilterDescriptor;

    if (value == null) {
      compositeFilter = this.removeFilter(this.filterField());
    } else {
      let operator = typeof value === 'string' ? 'contains' : 'eq';

      compositeFilter = this.updateFilter({
        field: this.filterField(),
        operator: operator,
        value: value
      });
    }

    this.applyFilter(compositeFilter);
  }

  public handleAutoCompleteEmployeeFilter(value, control) {
    if (value.length <= 2) {
      control.toggle(false);
      return this.filteredData = [];
    }

    this.filteredData = this.data().filter(this.doesNameMatch, value)
      .map(x => { return new EmployeeVM(x); })
      .sort(this.sortByName);
  }

  public resetList() {
    this.filteredData = this.getDefaultList(this.data());
  }

  private doesNameMatch(e: Employee): boolean {
    let value = this as any;
    let values = value.split(/[ ,]+/);
    let match = false;

    let firstName = e.PreferredFirstName && (e.PreferredFirstName).toString().toLowerCase() || '';
    let lastName = e.LastName && (e.LastName).toString().toLowerCase() || '';

    match = firstName.indexOf(values[0].toLowerCase()) !== -1 || lastName.indexOf(values[0].toLowerCase()) !== -1;

    if (match && values.length > 1 && values[1] !== '') {
      match = false;

      if (firstName.indexOf(values[1].toLowerCase()) !== -1 || lastName.indexOf(values[1].toLowerCase()) !== -1) {
        match = true;
      }
    }

    return match;
  }

  private sortByName(a: EmployeeVM, b: EmployeeVM) {
    if (a.FullName < b.FullName) {
      return -1;
    }

    if (a.FullName > b.FullName) {
      return 1;
    }

    return 0;
  }

  private getDefaultList(employees: any[]) {
    return employees.map(x => { return new EmployeeVM(x); }).sort(this.sortByName).slice(0, 10);
  }
}